import { calcProgram } from '../functions/calcProgram';

export const state = {
  importDialog: false,
  loading: false,
  courseLog: JSON.parse(localStorage.getItem('courseLog')) || [],
  programs: calcProgram((JSON.parse(localStorage.getItem('courseLog')) || []).filter(v => /(及格|成績未到)/.test(v.isPassed)).map(v => v.semester + v.no)),
  activeProgram: localStorage.getItem('activeProgram') || '法律',
};